import React, { ChangeEvent, FunctionComponent } from "react";

import { createQA } from "@multiweb/reactUtils";
import { QAProps } from "@multiweb/types/react";
import { getEditableControlClassName } from "./utils";

export type TextLOVEditComponentProps = {
    readonly value: string;
    readonly maxLength: number;
    readonly readOnly?: boolean;
    readonly required?: boolean;
    readonly isEditable?: boolean;
    readonly onClick: () => void;
    readonly onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
} & QAProps;

export const TextLOVEditComponent: FunctionComponent<TextLOVEditComponentProps> = ({ value = "", maxLength, readOnly = false, required = false, isEditable = true, onClick, qa, onChange }) => (
    <div {...createQA(qa)} className={getEditableControlClassName(required, readOnly, "LOVEdit")}>
        <input type="text" autoComplete="off" readOnly={readOnly || !isEditable} {...{ value, maxLength, onChange }} />
        <button disabled={readOnly} className="valuepicker" {...{ onClick }} />
    </div>
);
